import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const PropsTable = makeShortcode("PropsTable");
const PropsTableRow = makeShortcode("PropsTableRow");
const PropsTableSxRow = makeShortcode("PropsTableSxRow");
const PropsTableRefRow = makeShortcode("PropsTableRefRow");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Note variant="warning" mdxType="Note">Not implemented yet</Note>
    <h2>{`Examples`}</h2>
    <h3>{`Simple`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<SegmentedControl aria-label="File view">
  <SegmentedControl.Button selected>Preview</SegmentedControl.Button>
  <SegmentedControl.Button>Raw</SegmentedControl.Button>
  <SegmentedControl.Button>Blame</SegmentedControl.Button>
</SegmentedControl>
`}</code></pre>
    <h3>{`With icons and labels`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<SegmentedControl aria-label="File view">
  <SegmentedControl.Button selected leadingIcon={EyeIcon}>
    Preview
  </SegmentedControl.Button>
  <SegmentedControl.Button leadingIcon={FileCodeIcon}>Raw</SegmentedControl.Button>
  <SegmentedControl.Button leadingIcon={PeopleIcon}>Blame</SegmentedControl.Button>
</SegmentedControl>
`}</code></pre>
    <h3>{`With icons only`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<SegmentedControl aria-label="File view">
  <SegmentedControl.IconButton selected icon={EyeIcon} aria-label="Preview" />
  <SegmentedControl.IconButton icon={FileCodeIcon} aria-label="Raw" />
  <SegmentedControl.IconButton icon={PeopleIcon} aria-label="Blame" />
</SegmentedControl>
`}</code></pre>
    <h3>{`With labels hidden on smaller viewports`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<SegmentedControl aria-label="File view" variant={{narrow: 'hideLabels', regular: 'none'}}>
  <SegmentedControl.Button selected leadingIcon={EyeIcon}>
    Preview
  </SegmentedControl.Button>
  <SegmentedControl.Button leadingIcon={FileCodeIcon}>Raw</SegmentedControl.Button>
  <SegmentedControl.Button leadingIcon={PeopleIcon}>Blame</SegmentedControl.Button>
</SegmentedControl>
`}</code></pre>
    <h3>{`Convert to a dropdown on smaller viewports`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<SegmentedControl aria-label="File view" variant={{narrow: 'dropdown', regular: 'none'}}>
  <SegmentedControl.Button selected leadingIcon={EyeIcon}>
    Preview
  </SegmentedControl.Button>
  <SegmentedControl.Button leadingIcon={FileCodeIcon}>Raw</SegmentedControl.Button>
  <SegmentedControl.Button leadingIcon={PeopleIcon}>Blame</SegmentedControl.Button>
</SegmentedControl>
`}</code></pre>
    <h3>{`Fill width of parent`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<SegmentedControl fullWidth aria-label="File view">
  <SegmentedControl.Button selected>Preview</SegmentedControl.Button>
  <SegmentedControl.Button>Raw</SegmentedControl.Button>
  <SegmentedControl.Button>Blame</SegmentedControl.Button>
</SegmentedControl>
`}</code></pre>
    <h3>{`In a loading state`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<SegmentedControl loading aria-label="File view">
  <SegmentedControl.Button selected>Preview</SegmentedControl.Button>
  <SegmentedControl.Button>Raw</SegmentedControl.Button>
  <SegmentedControl.Button>Blame</SegmentedControl.Button>
</SegmentedControl>
`}</code></pre>
    <h3>{`With a label and caption on the left`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box display="flex">
  <Box flexGrow={1}>
    <Text fontSize={2} fontWeight="bold" id="scLabel-vert" display="block">
      File view
    </Text>
    <Text color="fg.subtle" fontSize={1} id="scCaption-vert" display="block">
      Change the way the file is viewed
    </Text>
  </Box>
  <SegmentedControl aria-labelledby="scLabel-vert" aria-describedby="scCaption-vert">
    <SegmentedControl.Button selected>Preview</SegmentedControl.Button>
    <SegmentedControl.Button>Raw</SegmentedControl.Button>
    <SegmentedControl.Button>Blame</SegmentedControl.Button>
  </SegmentedControl>
</Box>
`}</code></pre>
    <h3>{`With a label above and caption below`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<FormControl>
  <FormControl.Label id="scLabel-horiz">File view</FormControl.Label>
  <SegmentedControl aria-labelledby="scLabel-horiz" aria-describedby="scCaption-horiz">
    <SegmentedControl.Button selected>Preview</SegmentedControl.Button>
    <SegmentedControl.Button>Raw</SegmentedControl.Button>
    <SegmentedControl.Button>Blame</SegmentedControl.Button>
  </SegmentedControl>
  <FormControl.Caption id="scCaption-horiz">Change the way the file is viewed</FormControl.Caption>
</FormControl>
`}</code></pre>
    <h3>{`With something besides the first option selected`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<SegmentedControl aria-label="File view">
  <SegmentedControl.Button selected>Preview</SegmentedControl.Button>
  <SegmentedControl.Button selected>Raw</SegmentedControl.Button>
  <SegmentedControl.Button>Blame</SegmentedControl.Button>
</SegmentedControl>
`}</code></pre>
    <h3>{`With a selection change handler`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<SegmentedControl
  aria-label="File view"
  onChange={selectedIndex => {
    alert(\`Segment \${selectedIndex}\`)
  }}
>
  <SegmentedControl.Button>Preview</SegmentedControl.Button>
  <SegmentedControl.Button>Raw</SegmentedControl.Button>
  <SegmentedControl.Button>Blame</SegmentedControl.Button>
</SegmentedControl>
`}</code></pre>
    <h2>{`Props`}</h2>
    <h3>{`SegmentedControl`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="aria-label" type="string" mdxType="PropsTableRow" />
  <PropsTableRow name="aria-labelledby" type="string" mdxType="PropsTableRow" />
  <PropsTableRow name="aria-describedby" type="string" mdxType="PropsTableRow" />
  <PropsTableRow name="fullWidth" type="boolean" description="Whether the control fills the width of its parent" mdxType="PropsTableRow" />
  <PropsTableRow name="loading" type="boolean" description="Whether the selected segment is being calculated" mdxType="PropsTableRow" />
  <PropsTableRow name="onChange" type="(selectedIndex?: number) => void" description="The handler that gets called when a segment is selected" mdxType="PropsTableRow" />
  <PropsTableRow name="variant" type="{
      narrow?: 'hideLabels' | 'dropdown',
      regular?: 'hideLabels' | 'dropdown',
      wide?: 'hideLabels' | 'dropdown'
    }" description="Configure alternative ways to render the control when it gets rendered in tight spaces" mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
  <PropsTableRefRow refType="HTMLDivElement" mdxType="PropsTableRefRow" />
    </PropsTable>
    <h3>{`SegmentedControl.Button`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="aria-label" type="string" mdxType="PropsTableRow" />
  <PropsTableRow name="leadingIcon" type="Component" description="The leading icon comes before item label" mdxType="PropsTableRow" />
  <PropsTableRow name="selected" type="boolean" description="Whether the segment is selected" mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
  <PropsTableRefRow refType="HTMLButtonElement" mdxType="PropsTableRefRow" />
    </PropsTable>
    <h3>{`SegmentedControl.IconButton`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="aria-label" type="string" mdxType="PropsTableRow" />
  <PropsTableRow name="icon" type="Component" description="The icon that represents the segmented control item" mdxType="PropsTableRow" />
  <PropsTableRow name="selected" type="boolean" description="Whether the segment is selected" mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
  <PropsTableRefRow refType="HTMLButtonElement" mdxType="PropsTableRefRow" />
    </PropsTable>
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: false,
      adaptsToThemes: false,
      adaptsToScreenSizes: false,
      fullTestCoverage: false,
      usedInProduction: false,
      usageExamplesDocumented: false,
      hasStorybookStories: false,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      